export default __webpack_public_path__ + "static/media/downloadAshreyaWeb.fb61edc1.svg";